import App from 'app/app.js';
import confetti from 'canvas-confetti';

function ConfettiService($timeout) {
  this.fire = function () {
    $timeout(() => {
      const canvas = document.getElementById('confetti-canvas');

      if (!canvas) {
        console.warn('Confetti canvas not found: #confetti-canvas');
        return;
      }

      const create = () =>
        confetti.create(canvas, {
          resize: true,
          useWorker: false
        });

      // burst 1
      create()({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      });

      $timeout(() => {
        create()({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 }
        });
      }, 500);
    }, 0);
  };
}

App.service('ConfettiService', ['$timeout', ConfettiService]);
